// Shared Lead Tracking constants + helpers.

export const LEAD_STATUSES = [
  "new",
  "contacted",
  "tour_scheduled",
  "application_pending",
  "moved_in",
  "closed",
  "not_interested",
] as const;

export const LEAD_SOURCES = [
  "phone",
  "walk_in",
  "referral",
  "website",
  "email",
  "other",
] as const;

export const LEAD_INTEREST_LEVELS = ["hot", "warm", "cold", "inactive"] as const;

const STATUS_LABELS: Record<string, string> = {
  new: "New",
  contacted: "Contacted",
  tour_scheduled: "Tour scheduled",
  application_pending: "Application pending",
  moved_in: "Moved in",
  closed: "Closed",
  not_interested: "Not interested",
};

const SOURCE_LABELS: Record<string, string> = {
  phone: "Phone",
  walk_in: "Walk-in",
  referral: "Referral",
  website: "Website",
  email: "Email",
  other: "Other",
};

const INTEREST_LABELS: Record<string, string> = {
  hot: "Hot",
  warm: "Warm",
  cold: "Cold",
  inactive: "Inactive",
};

export function leadStatusLabel(s: string): string {
  return STATUS_LABELS[s] ?? s;
}

export function leadSourceLabel(s: string | null): string {
  if (!s) return "—";
  return SOURCE_LABELS[s] ?? s;
}

export function leadInterestLabel(s: string | null): string {
  if (!s) return "Warm";
  return INTEREST_LABELS[s] ?? s;
}

export function leadInterestBadge(s: string | null): string {
  if (s === "hot") return "alert";
  if (s === "cold") return "info";
  if (s === "inactive") return "muted";
  return "warn";
}

// Maps a lead status to a mockup badge colour class suffix.
export function leadStatusBadge(s: string): string {
  if (s === "moved_in") return "ok";
  if (s === "closed" || s === "not_interested") return "muted";
  if (s === "tour_scheduled" || s === "application_pending") return "warn";
  return "info"; // new, contacted
}

// Lead statuses where a follow-up is no longer actionable, so the lead
// should never read as "overdue" no matter how old the follow-up date is.
const LEAD_TERMINAL_STATUSES = new Set(["moved_in", "closed", "not_interested"]);

// True when an active lead's follow-up date has already passed.
// Mirrors isOverdue() for work orders.
export function isLeadOverdue(status: string, followUpDate: string | null): boolean {
  if (!followUpDate || LEAD_TERMINAL_STATUSES.has(status)) return false;
  const today = new Date().toISOString().slice(0, 10);
  return followUpDate < today;
}
